const mutations = {
  showDialog(state) {
    state.dialog = true;
  },

  hideDialog(state) {
    state.dialog = false;
  },

  setModel(state, model) {
    state.errorArray = [];
    state.uCurricular = model;
  },

  setModels(state, models) {
    state.uCurriculars = models;
  },

  addModel(state, model) {
    state.uCurriculars.unshift(model);
  },

  delModel(state, id) {
    const removeIndex = state.uCurriculars
      .map(function (item) {
        return item.id;
      })
      .indexOf(id);
    state.uCurriculars.splice(removeIndex, 1);
  },

  setErrors(state, errors) {
    state.errorArray = errors;
  },

  setFields(state, data) {
    state.fields = data.fields;
    state.emptyModel = data.model;
  },
};

export default mutations;
